var FactoryResolver_1;
import * as tslib_1 from "tslib";
import { containerResolver } from '../protocol/resolver';
import { Strategy } from '../types';
/**
 * Used to allow injecting dependencies but also passing data to the constructor.
 */
let FactoryResolver = FactoryResolver_1 = class FactoryResolver {
    /**
     * Creates an instance of the Factory class.
     * @param key The key to resolve from the parent container.
     */
    constructor(key) {
        this._key = key;
    }
    /**
     * Creates a Factory Resolver for the supplied key.
     * @param key The key to resolve.
     * @return Returns an instance of Factory for the key.
     */
    static of(key) {
        return new FactoryResolver_1(key);
    }
    /**
     * Called by the container to pass the dependencies to the constructor.
     * @param container The container to invoke the constructor with dependencies and other parameters.
     * @return Returns a function that can be invoked to resolve dependencies later, and the rest of the parameters.
     */
    get(container, key) {
        let _key = this._key;
        let resolver = container.getResolver(_key);
        if (resolver && resolver.strategy === Strategy.Function) {
            _key = resolver.state;
        }
        // tslint:disable-next-line:only-arrow-functions
        return function (...rest) {
            return container.invoke(_key, rest);
        };
    }
};
FactoryResolver = FactoryResolver_1 = tslib_1.__decorate([
    containerResolver,
    tslib_1.__metadata("design:paramtypes", [Object])
], FactoryResolver);
export { FactoryResolver };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmFjdG9yeVJlc29sdmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiRmFjdG9yeVJlc29sdmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBT0EsT0FBTyxFQUFFLGlCQUFpQixFQUFFLE1BQU0sc0JBQXNCLENBQUM7QUFDekQsT0FBTyxFQUFnQyxRQUFRLEVBQUUsTUFBTSxVQUFVLENBQUM7QUFFbEU7O0dBRUc7QUFFSCxJQUFhLGVBQWUsdUJBQTVCLE1BQWEsZUFBZTtJQWF4Qjs7O09BR0c7SUFDSCxZQUFtQixHQUFXO1FBQzFCLElBQUksQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDO0lBQ3BCLENBQUM7SUFsQkQ7Ozs7T0FJRztJQUNJLE1BQU0sQ0FBQyxFQUFFLENBQXNDLEdBQVc7UUFDN0QsT0FBTyxJQUFJLGlCQUFlLENBQUksR0FBRyxDQUFDLENBQUM7SUFDdkMsQ0FBQztJQWFEOzs7O09BSUc7SUFDSSxHQUFHLENBQUMsU0FBb0IsRUFBRSxHQUFXO1FBQ3hDLElBQUksSUFBSSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUM7UUFDckIsSUFBSSxRQUFRLEdBQUcsU0FBUyxDQUFDLFdBQVcsQ0FBQyxJQUFXLENBQUMsQ0FBQztRQUNsRCxJQUFJLFFBQVEsSUFBSyxRQUFnQixDQUFDLFFBQVEsS0FBSyxRQUFRLENBQUMsUUFBUSxFQUFFO1lBQzlELElBQUksR0FBSSxRQUFnQixDQUFDLEtBQUssQ0FBQztTQUNsQztRQUNELGdEQUFnRDtRQUNoRCxPQUFPLFVBQVMsR0FBRyxJQUFXO1lBQzFCLE9BQU8sU0FBUyxDQUFDLE1BQU0sQ0FBQyxJQUFXLEVBQUUsSUFBSSxDQUFDLENBQUM7UUFDL0MsQ0FBTSxDQUFDO0lBQ1gsQ0FBQztDQUNKLENBQUE7QUFyQ1ksZUFBZTtJQUQzQixpQkFBaUI7O0dBQ0wsZUFBZSxDQXFDM0I7U0FyQ1ksZUFBZSJ9